class WishlistSelect extends HTMLElement {
    constructor() {
      super();
      this.wishlistSelect = this.querySelector('.wishlist-dropdown-js');
      this.quickBuy = this.nextElementSibling;

      this.wishlistSelect.addEventListener('change', () => this.onChange());

    }
  
    onChange() {
      this.quickBuy.dataset.id = this.wishlistSelect.value;
    }
}
  
customElements.define('wishlist-select', WishlistSelect);
